
export enum DeltaSignCd {
	NEGATIVE = 'Negative',
	NEUTRAL = 'Neutral',
	POSITIVE = 'Positive'}

